// Central place to manage backend endpoints used by the UI
// Base URL is configurable via REACT_APP_API_BASE_URL (e.g., http://localhost:7233/api)
const envBase = process.env.REACT_APP_API_BASE_URL;

export const apiConfig = {
	// Base URL to your backend API (no trailing slash preferred)
	baseUrl: (envBase && String(envBase).replace(/\/$/, "")) || "https://prod-application-tools-gwdzegbkh2ddahc8.centralus-01.azurewebsites.net/api",
	// Paths to API endpoints (versioned)
	cwProjectsPath: "/v1/cw_projects",
	cwProjectTicketsPath: "/v1/cw_project_tickets",
	cwScheduledResourcesPath: "/v1/cw_scheduled_resources",
	cwWorkRolesPath: "/v1/cw_workroles",
	cwUsersPath: "/v1/cw_users",
	// New endpoints for project roles and add-member action
	cwProjectRolesPath: "/v1/cw_project_roles",
	cwAddMemberToProjectBasePath: "/v1/cw_add_member_to_project",
    // Permissions endpoint
    cwPermissionsPath: "/v1/permissions",
    // Paycor time-off endpoint
    paycorTimeOffPath: "/v1/paycor_timeoff",
    // ConnectWise service board statuses
    cwServiceBoardStatusBasePath: "/v1/cw_service_board_status",
    // ConnectWise ticket
    cwTicketBasePath: "/v1/cw_ticket",
    // Soft scheduling side-database
    rmSoftSchedulePath: "/v1/rm_soft_schedule",
};

// Generic URL builder with query params support (e.g., { conditions: "foo" })
export function buildApiUrl(path, params) {
	const base = String(apiConfig.baseUrl).replace(/\/$/, "");
	const url = new URL(`${base}${path}`);
	if (params && typeof params === "object") {
		Object.entries(params).forEach(([key, value]) => {
			if (value !== undefined && value !== null && String(value).length > 0) {
				url.searchParams.set(key, String(value));
			}
		});
	}
	return url.toString();
}

// Convenience helpers for specific endpoints
export function getProjectsUrl(conditions) {
	return buildApiUrl(apiConfig.cwProjectsPath, conditions ? { conditions } : undefined);
}

export function getProjectTicketsUrl(conditions, extraParams) {
	if (conditions && typeof conditions === "object" && !extraParams) {
		// Back-compat: allow passing full params object directly
		return buildApiUrl(apiConfig.cwProjectTicketsPath, conditions);
	}
	const params = conditions ? { conditions } : {};
	if (extraParams && typeof extraParams === "object") {
		Object.assign(params, extraParams);
	}
	return buildApiUrl(apiConfig.cwProjectTicketsPath, Object.keys(params).length ? params : undefined);
}

export function getScheduledResourcesUrl(conditions, extraParams) {
	if (conditions && typeof conditions === "object" && !extraParams) {
		// Back-compat: allow passing full params object directly
		return buildApiUrl(apiConfig.cwScheduledResourcesPath, conditions);
	}
	const params = conditions ? { conditions } : {};
	if (extraParams && typeof extraParams === "object") {
		Object.assign(params, extraParams);
	}
	return buildApiUrl(apiConfig.cwScheduledResourcesPath, Object.keys(params).length ? params : undefined);
}

export function getWorkRolesUrl(conditions) {
	return buildApiUrl(apiConfig.cwWorkRolesPath, conditions ? { conditions } : { conditions: "inactiveFlag=false" });
}

export function getUsersByWorkRoleIdsUrl(workRoleIds, extraConditions) {
	const baseCond = workRoleIds && workRoleIds.length
		? `workRole/id in (${workRoleIds.join(',')}) and inactiveFlag=false`
		: "inactiveFlag=false";
	const conditions = extraConditions ? `${baseCond} and (${extraConditions})` : baseCond;
	return buildApiUrl(apiConfig.cwUsersPath, { conditions });
}

// Convenience helpers for new endpoints
export function getProjectRolesUrl() {
    return buildApiUrl(apiConfig.cwProjectRolesPath);
}

export function getAddMemberToProjectUrl(projectId) {
    const base = String(apiConfig.baseUrl).replace(/\/$/, "");
    return `${base}${apiConfig.cwAddMemberToProjectBasePath}/${projectId}`;
}

export function getPermissionsUrl() {
	return buildApiUrl(apiConfig.cwPermissionsPath);
}

export function getPaycorTimeOffUrl(conditions) {
	return buildApiUrl(apiConfig.paycorTimeOffPath, conditions ? { conditions } : undefined);
}

export function getServiceBoardStatusUrl(boardId) {
	const base = String(apiConfig.baseUrl).replace(/\/$/, "");
	return `${base}${apiConfig.cwServiceBoardStatusBasePath}/${boardId}`;
}
